import { savyKulma } from '@tk/shared';
import type { CSSProperties } from 'react';

/**
 * Asiakasvärin sitominen elementtiin.
 *
 * Paletti ja sävyn ratkaisu ovat `@tk/shared`issa, koska palvelin
 * validoi `colorKey`n samasta luettelosta. Täällä on vain se osa, joka
 * koskee selainta: yhden CSS-muuttujan asettaminen.
 */

/**
 * Tyyliolio, joka annetaan sävyä käyttävälle elementille.
 *
 * Elementille menee **yksi luku**, ei väriä: värin muodostaa CSS
 * (`.asiakas-siru`, `.asiakas-raita`, `.asiakas-piste`, `.asiakas-teksti`),
 * joka tuntee teeman. Näin tumma teema hoituu ilman, että yksikään
 * komponentti kysyy, kumpi teema on käytössä.
 */
export function savyTyyli(asiakasKoodi: string, colorKey?: string | null): CSSProperties {
  return { '--asiakkaan-savy': savyKulma(asiakasKoodi, colorKey) } as CSSProperties;
}
